/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ActiveVesrionConfirmModal extends React.Component {
  render() {
    return (
      <div>
        <Modal isOpen={this.props.visible} toggle={this.props.toggle} className={this.props.className}>
          <ModalHeader toggle={this.props.toggle}>Make Version Active</ModalHeader>
          <ModalBody>
            Are you sure that you want to make version {this.props.file.version} the active version?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.props.makeTemplateActiveVersion(this.props.file)}>Yes</Button>{' '}
            <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ActiveVesrionConfirmModal;